import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import { useTranslation } from "react-i18next";
import ButtonAtom from '../button/button';
import "./modal.scss";

function ModalAtom(props) {
	const {
		show, handleClose, handleSubmit, title, body, centered = true,
		saveText, footer, customClassName = '', hideCloseButton = false,
		titleHelpText = '', headerButtons = null
	} = props;
	const { t } = useTranslation();

	return (
		<Modal show={show} onHide={handleClose} centered={centered} className={customClassName} backdrop="static">
			<Modal.Header>
				<Modal.Title>{title}&nbsp;
					{titleHelpText && <OverlayTrigger overlay={<Tooltip>{titleHelpText}</Tooltip>}>
						<FontAwesomeIcon icon={faCircleInfo} />
					</OverlayTrigger>}
				</Modal.Title>
				<div className='modal-btn-container'>
					{headerButtons && <div className="header-buttons">{headerButtons}</div>}
					{!hideCloseButton && <ButtonAtom onClick={handleClose} className="modal-close-btn">
						{t('close')}
					</ButtonAtom>}
					<ButtonAtom className="mx-2 text-white btn btn-primary" onClick={handleSubmit}>
						{t(saveText || 'save')}
					</ButtonAtom>
				</div>
			</Modal.Header>
			<Modal.Body>
				{body}
			</Modal.Body>
			{footer && <Modal.Footer>
				{footer}
			</Modal.Footer>
			}
		</Modal>
	);
}
export default ModalAtom;
